import { getIsComparisonApiPending, getQuoteForm, getQuote } from '../../../selectors/afyaImara/quote';
import {
    apiTransitionAfyaImaraInsuranceComparison,
    fetchComparisonDataSuccess,
} from '../../../actions/afyaImara/quote';
import { getAccessToken } from '../../../selectors/afyaImara/payments';
import axios from 'axios';


// sample payload

// {
//     "countryCode": "KE",
//     "productId": 1,
//     "age": 53,
//     "inPatient": {
//         "inpatientLimitId": 1
//     },
//     "outPatient": {
//         "present": true,
//         "outpatientLimitId": 1,
//         "option": 1
//     },
//     "familyMembers": {
//         "children": {
//             "count": 2
//         },
//         "spouse": {
//             "age": 53
//         }
//     }
// }

export const getProductComparisonService = (store, next, action) => {
    (async () => {
        if (!getIsComparisonApiPending(store.getState())) {
            store.dispatch(apiTransitionAfyaImaraInsuranceComparison.pending());
            try {
                const resp = await calculate(store.getState());
                store.dispatch(fetchComparisonDataSuccess(resp.data));
                store.dispatch(apiTransitionAfyaImaraInsuranceComparison.success());
            } catch (e) {
                console.error(e);
                store.dispatch(apiTransitionAfyaImaraInsuranceComparison.failure());
            }
        }
    })();
    return next(action);
};

function getAgeFromDateString(dateString) {
    if(!dateString || dateString == null){
        return null
    }
    // Split the date string into day, month, and year components
    const [day, month, year] = dateString.split('/').map(Number);

    // Create a Date object for the date of birth
    const birthDate = new Date(year, month - 1, day); // Month is 0-indexed in JavaScript Date

    // Get the current date
    const today = new Date();

    // Calculate the age
    let age = today.getFullYear() - birthDate.getFullYear();

    // Adjust age if the current date is before the birthdate in the current year
    const currentMonth = today.getMonth();
    const birthMonth = birthDate.getMonth();
    if (currentMonth < birthMonth || (currentMonth === birthMonth && today.getDate() < birthDate.getDate())) {
        age--;
    }

    return age;
}


const premiumComparisonPayload = (state) => {
    const quote = getQuote(state)
    const quotation = getQuoteForm(state);
    const productId = quote?.productId || null;
    const seniorProductId = ["2"]
    const juniorProductId = ["6", "3"]
    const familyProductId = ["1"]
    const executiveProductId = ["5"]
    const countryProductId = ["4"]


    const juniorPremiumCalculationPayload = {
        countryCode: 'KE',
        productId: productId,
        age: 0,
        inPatient: {
            inpatientLimitId: quotation?.inpatientCover?.value,
        },
        outPatient: {
            present: quotation?.outpatientCover?.value ? true : false,
            outpatientLimitId: quotation?.outpatientCover?.value,
            option: quotation?.outpatientCoverOption?.value !== 'per family per annum' ? 2 : 1
        },
        familyMembers: {
            children: {
                count: quotation?.childrenDobs?.value?.length || 0,
            },
            spouse: {
                age: 0,
            },
        },
    };

     const seniorPremiumCalculationPayload = {
         countryCode: 'KE',
         productId: 2,
         age: getAgeFromDateString(quotation?.dob?.value) || 0,
         inPatient: {
             inpatientLimitId: quotation?.inpatientCover?.value,
         },
         outPatient: {
             present: true,
             outpatientLimitId: quotation?.outpatientCover?.value,
             option: quotation?.outpatientCover?.value,
         },
         familyMembers: {
             children: {
                 count: quotation?.childrenDobs?.value?.length || 0,
             },
             spouse: {
                 age: 0,
             },
         },
     };

    const familyPremiumCalculationPayload = {
        countryCode: 'KE',
        productId: 1,
        age: getAgeFromDateString(quotation?.dob?.value) || 0,
        inPatient: {
            inpatientLimitId: quotation?.inpatientCover?.value,
        },
        outPatient: {
            present: true,
            outpatientLimitId: quotation?.outpatientCover?.value,
            option: quotation?.outpatientCover?.value,
        },
        familyMembers: {
            children: {
                count: quotation?.childrenDobs?.value?.length || 0,
            },
            spouse: {
                age: parseInt(quotation?.spouseDob?.value) || 0,
            },
        },
    };

    const executivePremiumCalculationPayload = {
        countryCode: 'KE',
        productId: 5,
        age: getAgeFromDateString(quotation?.dob?.value) || 0,
        inPatient: {
            inpatientLimitId: quotation?.inpatientCover?.value,
        },
        outPatient: {
            present: quotation?.outpatientCover?.value ? true : false,
            outpatientLimitId: quotation?.outpatientCover?.value || 0,
            option: quotation?.outpatientCover?.value || 0,
        },
        familyMembers: {
            children: {
                count: quotation?.childrenDobs?.value?.length || 0,
            },
            spouse: {
                age: 0,
            },
        },
    };

    const countyPremiumCalculationPayload = {
        countryCode: 'KE',
        productId: 4,
        age: getAgeFromDateString(quotation?.dob?.value) || 0,
        inPatient: {
            inpatientLimitId: quotation?.inpatientCover?.value,
        },
        outPatient: {
            present: quotation?.outpatientCover?.value ? true : false,
            outpatientLimitId: quotation?.outpatientCover?.value || 0,
            option: quotation?.outpatientCover?.value || 0,
        },
        familyMembers: {
            children: {
                count: quotation?.childrenDobs?.value?.length || 0,
            },
            spouse: {
                age: 0,
            },
        },
    };

    // check if product id is either in junior, senior or family then return the payload
    if (juniorProductId.includes(productId)) {
        return {
            ...juniorPremiumCalculationPayload,
        };
    } else if (seniorProductId.includes(productId)) {
        return {
            ...seniorPremiumCalculationPayload,
        };
    } else if (familyProductId.includes(productId)) {
        return {
            ...familyPremiumCalculationPayload,
        };
    } else if (executiveProductId.includes(productId)) {
        return {
            ...executivePremiumCalculationPayload,
        };
    } else if (countryProductId.includes(productId)) {
        return {
            ...countyPremiumCalculationPayload,
        };
    }
};

const calculate = async (state) => {
    const loginData = getAccessToken(state);
    try {
        const url = '/om-api/ke-afya-imara/product-comparison';
        return await axios.post(url, premiumComparisonPayload(state), {
            headers: {
                'Content-Type': 'application/json',
                accessToken: loginData.accessToken,
            },
        });
    } catch (e) {
        console.error(e);
        throw e;
    }
};
